import { AnimatePresence } from 'motion/react';
import { Outlet, ScrollRestoration } from 'react-router';
import { Toaster } from 'sonner';
import { Footer } from 'src/components/layout/footer.tsx';
import { Header } from 'src/components/layout/header.tsx';
import { useCheck } from 'src/state/check-context.ts';
import { CheckProvider } from 'src/state/check-provider.tsx';

function AppShell() {
  const { reset } = useCheck();
  return (
    <div
      className="relative min-h-screen w-full bg-background text-foreground"
      style={{ fontFamily: 'var(--font-sans)' }}>
      <Toaster position="top-center" richColors />
      <Header onLogoClick={reset} />
      <ScrollRestoration />
      <AnimatePresence mode="wait">
        <Outlet />
      </AnimatePresence>
      <Footer />
    </div>
  );
}

export function RootLayout() {
  return (
    <CheckProvider>
      <AppShell />
    </CheckProvider>
  );
}
